"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var hocs_1 = require("../hocs");
var FormLabel_1 = require("../FormLabel");
var StyledTextInput_1 = require("../TextInput/StyledTextInput");
var withFormFields_hoc_1 = require("../withFormFields/withFormFields.hoc");
var StyledMessageArea_1 = require("./StyledMessageArea");
function renderLabel(suggestion) {
    if (suggestion && suggestion !== null && typeof suggestion === 'object') {
        return suggestion.label || suggestion.value;
    }
    return suggestion;
}
var MessageAreaInner = function (props) {
    var inputRef = React.createRef();
    var forwardRef = props.forwardRef, placeholder = props.placeholder, label = props.label, theme = props.theme, value = props.value, error = props.error, errorIcon = props.errorIcon, errorMessage = props.errorMessage, id = props.id, autoComplete = props.autoComplete, rest = tslib_1.__rest(props, ["forwardRef", "placeholder", "label", "theme", "value", "error", "errorIcon", "errorMessage", "id", "autoComplete"]);
    return (React.createElement(StyledMessageArea_1.StyledMessageAreaContainer, null,
        label && (React.createElement(FormLabel_1.FormLabel, null,
            label,
            " ",
            error && errorIcon)),
        placeholder && typeof placeholder !== 'string' && !value ? (React.createElement(StyledTextInput_1.StyledPlaceholder, { theme: theme }, placeholder)) : null,
        React.createElement(StyledMessageArea_1.StyledMessageArea, tslib_1.__assign({ ref: forwardRef || inputRef, autoComplete: autoComplete || '-', placeholder: typeof placeholder === 'string' ? placeholder : undefined, theme: theme, value: renderLabel(value) || '', error: error, id: id, "aria-invalid": !!error }, rest)),
        error && (React.createElement(StyledTextInput_1.StyledError, { theme: theme, id: id && "error-" + id }, errorMessage))));
};
/** @components */
exports.MessageArea = recompose_1.compose(hocs_1.withFocus, styled_components_1.withTheme, hocs_1.withForwardRef)(MessageAreaInner);
exports.FormMessageArea = withFormFields_hoc_1.withFormFields(MessageAreaInner);
//# sourceMappingURL=MessageArea.js.map